import { productColumnOptions } from "./dataExample/productColumnOptions";
import { Tag, Typography, Space, Collapse } from "antd";
import { useTranslation } from "react-i18next";
import React from "react";

const { Title, Text } = Typography;

export default function ProductGuide(): React.ReactElement {
  const { t } = useTranslation();

  const basicFields = productColumnOptions.filter(col => col.category === "basic");
  const pricingFields = productColumnOptions.filter(col => col.category === "pricing");

  const renderColumnCard = (column: (typeof productColumnOptions)[0], index: number) => (
    <div key={index} className="column-card">
      <Space direction="vertical" size={4} className="column-space">
        <div className="column-header">
          <Text className="column-field-name">{column.field}</Text>
          {column.required && (
            <Tag color="red" className="required-tag">
              {t("Required")}
            </Tag>
          )}
        </div>
        <Text type="secondary" className="column-description">
          {t(column.description)} • <Text italic>{column.example}</Text>
        </Text>
        {column.options && (
          <div className="options-wrapper">
            <Collapse ghost>
              <Collapse.Panel
                key="1"
                header={
                  <Space size={[4, 4]} wrap>
                    <Text strong className="collapse-header-text">
                      {t("View all")} {column.options.length} {t("options")}:
                    </Text>
                    {column.options.slice(0, 5).map((option, optIndex) => (
                      <Tag key={optIndex} className="option-tag">
                        {option.code}
                      </Tag>
                    ))}
                    {column.options.length > 5 && (
                      <Tag className="option-tag">+{column.options.length - 5}</Tag>
                    )}
                  </Space>
                }
              >
                <Space direction="vertical" size={4} className="options-list">
                  {column.options.map((option, optIndex) => (
                    <div key={optIndex} className="option-item">
                      <Tag className="option-tag option-tag-code">{option.code}</Tag>
                      <Text className="option-label-text">{t(option.label)}</Text>
                    </div>
                  ))}
                </Space>
              </Collapse.Panel>
            </Collapse>
          </div>
        )}
      </Space>
    </div>
  );

  return (
    <div className="client-info-guide">
      <Space direction="vertical" size="middle" className="guide-space">
        <div>
          {basicFields.map((col, idx) => renderColumnCard(col, idx))}
          {pricingFields.map((col, idx) => renderColumnCard(col, idx))}
        </div>

        <div className="notes-section">
          <Title level={5} className="notes-title">
            {t("Important Notes")}
          </Title>
          <Space direction="vertical" size={2}>
            <Text className="note-text">
              •{" "}
              <Text strong>
                {t(
                  "Product families (product types) must exist before importing products - create or import them first",
                )}
              </Text>
            </Text>
            <Text className="note-text">
              • {t("All column headers must be in French exactly as shown above")}
            </Text>
            <Text className="note-text">
              • {t("Category references must match existing categories in your system")}
            </Text>
            <Text className="note-text">
              • {t("Unit of measure codes must match existing units (u, kg, l, h, m, etc.)")}
            </Text>
            <Text className="note-text">
              • {t("The file must be in .xlsx, .xls, or .csv format")}
            </Text>
            <Text className="note-text">• {t("Maximum 2000 lines per file")}</Text>
            <Text className="note-text">
              • {t("Empty cells are allowed for non-required fields")}
            </Text>
            <Text className="note-text">
              • {t("Download the model file for a template with all available columns")}
            </Text>
          </Space>
        </div>
      </Space>
    </div>
  );
}
